import { create } from "zustand";
import {devtools } from "zustand/middleware";
import aemMock from "../../public/aemMock.json";

export interface UserDetails {
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
}

// Define the store's state and actions types
interface ApplicationStatusState {
  aemContent: typeof aemMock;
  applicationId: string;
  productName: string;
  applicationDate: string;
  OTPAttemptsLeft: number;
  userDetails: UserDetails;
  applicationStatus: string;
  securityToken: string;
  ngSecurityToken: string;
  verificationType: "phone" | "email";
  salesForceLeadId: string;
  emailValue: string;
  setSalesForceLeadId: (id: string) => void;
  setVerificationType: (type: "phone" | "email") => void;
  setApplicationId: (id: string) => void;
  setProductName: (name: string) => void;
  setApplicationDate: (date: string) => void;
  setSecurityToken: (token: string) => void;
  setNgSecurityToken: (token: string) => void;
  setOTPAttemptsLeft: (attempts: number) => void;
  setUserDetails: (details: UserDetails) => void;
  setApplicationStatus: (status: string) => void;
  setEmailValue: (email: string) => void;
  reset: () => void;
}

const useStore = create<ApplicationStatusState>()(
  devtools(
    (set) => ({
      applicationId: "",
      aemContent: aemMock,
      OTPAttemptsLeft: 3,
      userDetails: {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
      },
      applicationStatus: "",
      productName: "",
      applicationDate: "",
      securityToken: "",
      ngSecurityToken: "",
      verificationType: "phone",
      salesForceLeadId: "",
      emailValue: "",
      setSalesForceLeadId: (id) => set({ salesForceLeadId: id }),
      setVerificationType: (type) => set({ verificationType: type }),
      setApplicationId: (id) => set({ applicationId: id }),
      setSecurityToken: (token) => set({ securityToken: token }),
      setNgSecurityToken: (token) => set({ ngSecurityToken: token }),
      setOTPAttemptsLeft: (attempts) => set({ OTPAttemptsLeft: attempts }),
      setUserDetails: (details) => set({ userDetails: details }),
      setApplicationStatus: (status) => set({ applicationStatus: status }),
      setProductName: (name) => set({ productName: name }),
      setApplicationDate: (date) => set({ applicationDate: date }),
      setEmailValue: (email: string) => set({ emailValue: email }),
      reset: () =>
        set({
          applicationId: "",
          aemContent: aemMock,
          OTPAttemptsLeft: 3,
          userDetails: {
            firstname: "",
            lastname: "",
            email: "",
            phone: "",
          },
          applicationStatus: "",
          securityToken: "",
          ngSecurityToken: "",
          verificationType: "phone",
          salesForceLeadId: "",
          emailValue: "",
        }),
    }),
  ),
);

export { useStore };
